import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-link-tracker',
  templateUrl: './link-tracker.component.html',
  styleUrls: ['./link-tracker.component.scss']
})
export class LinkTrackerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
